import { useForm as useFormHook } from "hooks";
import { find, when } from "util/support";
import type { BankingSdkRecipient } from "features/openBanking/types";
import {
    BankingSDKRecipientForm,
    BootstrapData,
    FormField,
    type BankingSDKRecipient
} from "./types";
import useValidationSchema from "./useValidationSchema";

export const getInitialValues = ({
    addressType,
    country,
    ...restInitialValues
}: Partial<BankingSdkRecipient> = {}, bootstrapData: BootstrapData): BankingSDKRecipient => ({
    [FormField.EndToEndIdSlug]: '',
    [FormField.Name]: '',
    [FormField.AddressType]: find(bootstrapData.addressType, 'id')(String(addressType)) ?? null,
    [FormField.Department]: '',
    [FormField.SubDepartment]: '',
    [FormField.StreetName]: '',
    [FormField.BuildingNumber]: '',
    [FormField.PostCode]: '',
    [FormField.TownName]: '',
    [FormField.Country]: when(country, () => Array.of(country), ''),
    [FormField.CountrySubdivision]: '',
    [FormField.IbanAccount]: '',
    [FormField.BbanAccount]: '',
    [FormField.AgentBicFi]: '',
    [FormField.ClearingMemberId]: '',
    [FormField.AccountCurrency]: '',
    ...restInitialValues
});

export const useForm = (bankingSdkRecipientForm: BankingSDKRecipientForm) =>
    useFormHook({
        enableReinitialize: true,
        ...bankingSdkRecipientForm,
        validateOnMount: true,
        validationSchema: useValidationSchema()
    });
